import { faBars, faChevronLeft } from "@fortawesome/pro-thin-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { AppBar, Box, Breadcrumbs, IconButton, Stack, styled, Toolbar, Typography, useMediaQuery, useTheme } from "@mui/material";
import Link from "@mui/material/Link";
import { useNavigate } from "react-router-dom";
import { useAppBar } from "./AppBarProvider";
import { DRAWER_WIDTH } from "./AppDrawer";

const StyledAppBar = styled(AppBar, { shouldForwardProp: (prop) => prop !== "open" && prop !== "isSmallScreen" })<{
  open?: boolean;
  isSmallScreen?: boolean;
}>(({ theme, open, isSmallScreen }) => ({
  borderBottomColor: theme.palette.divider,
  zIndex: theme.zIndex.drawer - 1,
  borderBottomStyle: "solid",
  borderBottomWidth: 1,
  backgroundColor: "#ffffff",
  boxShadow: "none",
  transition: theme.transitions.create("padding", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  paddingLeft: isSmallScreen ? 0 : `${open ? DRAWER_WIDTH : 0}px`,
  ...(open && {
    transition: theme.transitions.create("padding", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export function GlobalAppBar(props: { title?: string; toggleDrawer: () => void; drawerOpen: boolean }) {
  const { toggleDrawer } = props;
  const context = useAppBar();
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  function handleBreadcrumbClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
    event.preventDefault();
    const href = event.currentTarget.getAttribute("href");
    if (href) {
      navigate(href);
    }
  }

  function handleGoBack() {
    if (context.backUrl) {
      navigate(context.backUrl);
    }
  }

  const breadcrumbs = context.breadcrumbs.map((bc, index) => {
    if (index === context.breadcrumbs.length - 1) {
      return (
        <Typography key="3" sx={{ color: "text.primary" }}>
          {bc.title}
        </Typography>
      );
    }
    return (
      <Link key={bc.path} underline="hover" color="inherit" href={bc.path} onClick={handleBreadcrumbClick}>
        {bc.title}
      </Link>
    );
  });

  return (
    <>
      <Box mb="64px" />
      <StyledAppBar position="fixed" open={props.drawerOpen} isSmallScreen={isSmallScreen}>
        <Toolbar>
          {isSmallScreen && (
            <IconButton size="large" edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer}>
              <FontAwesomeIcon icon={faBars} style={{ color: "#000000" }} />
            </IconButton>
          )}
          {context.backUrl && (
            <IconButton size="large" sx={{ mr: 2 }} onClick={handleGoBack}>
              <FontAwesomeIcon icon={faChevronLeft} style={{ color: "#000000", width: 28, height: 28 }} />
            </IconButton>
          )}
          <Stack flexGrow={1}>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: "black" }}>
              {context.title}
            </Typography>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              {breadcrumbs}
            </Breadcrumbs>
          </Stack>
          {context.rightContent}
        </Toolbar>
      </StyledAppBar>
    </>
  );
}
